module.exports = __webpack_public_path__ + "img/web2.0animation.63b84945.gif";